import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { SportTypeSelectionInput } from './SportCategoryTypeSelectionInput';
import { BORDER_COLOR, FADED_ICON_ERROR, WHITE } from '~/Constants/Colors.constants';
import { Typography } from '~/UIKit';
import { connect, getIn, FormikContextType } from 'formik';
import { ExtendedEventGroup } from '../../../ExtendedEventGroup.model';
import { makeStyles } from '~/UIKit/Style';
import { ItemCreationToolTip, ItemCreationToolTipProps } from '~/Components';

interface SportCategoryTypeSelectionProps {
  disabled?: boolean;
  tooltip?: Omit<ItemCreationToolTipProps, 'containerRef'> | false;
}
const useStyles = ({ disabled, hasError }: { disabled: boolean; hasError: boolean }) =>
  makeStyles(
    () => ({
      container: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: ' 0 15px',
        height: '50px',
        position: 'relative',
        borderBottom: `thin solid ${BORDER_COLOR}`,
        backgroundColor: hasError ? FADED_ICON_ERROR : WHITE,
        opacity: disabled ? 0.4 : 1,
      },
      title: {
        display: 'flex',
        alignItems: 'center',
      },
    }),
    { name: 'SportCategoryTypeSelection' },
  );

export const SportCategoryTypeSelection = connect<
  SportCategoryTypeSelectionProps,
  ExtendedEventGroup
>(
  ({
    disabled,
    tooltip,
    formik,
  }: SportCategoryTypeSelectionProps & { formik: FormikContextType<ExtendedEventGroup> }) => {
    const fieldName = 'categoryId';
    const updateSportCategoryType = (type: number) => {
      formik.setFieldValue(fieldName, type);
    };
    const { t } = useTranslation();
    const hasError = !!formik.errors[fieldName];
    const containerRef = useRef(null);
    const { classes } = useStyles({ disabled: !!disabled, hasError })();
    const categoryId = getIn(formik.values, fieldName);
    return (
      <div className={classes.container} ref={containerRef}>
        <Typography className={classes.title}>
          {`${t('event.sportCategory')}*`}{' '}
          <ItemCreationToolTip {...tooltip} containerRef={containerRef} />
        </Typography>
        <SportTypeSelectionInput
          selectedSportCategoryType={categoryId}
          updateSportCategoryType={updateSportCategoryType}
          disabled={disabled}
        >
          {t('event.selectCategory')}
        </SportTypeSelectionInput>
      </div>
    );
  },
);
